<template>
  <div class="list-container">     
    <div class="list">     
      <div class="content">
        <div class="teads_here1"></div>   
        <a
          v-for="item in list"
          :key="item.ID"
          class="newsBox"
          :href="`/detail/${item.ID}`"
        >
          <div class="newsImg">
            <img :src="item.meta_attached_file" alt="" />
          </div>
          <div class="labelBox">
            <a
              v-for="(val, index) in item.post_tag"
              :key="index"
              class="newsLabel"
              :href="`/list/tag/${(val || '').toLocaleLowerCase()}`"
              >#{{ val }}</a
            >
          </div>
          <div class="newsIntroduct">{{ item.post_title }}</div>
          <div class="newsContent">{{ item.post_excerpt }}</div>
          <div class="newsDate">{{ item.post_date }}</div>
        </a>
        <div class="teads_here2"></div>   
      </div>     
    </div> 
  </div>
</template>

<script>
import Mixin from "@/util/mixin";
export default {
  name: "List",
  mixins: [Mixin],
  components: {

  },
  data() {
    return {
      pageSize: 18,
      list: []
  
    };
  },

  
  mounted() {
    // let script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.async = true
    // script.src = "https://a.teads.tv/page/212757/tag"
    // document.body.appendChild(script);
    this.list = [
      {
        "ID": "102826",
        "post_title": "渋谷の新スポット NANZUKA TAKEN は東京アート異界の入り口",
        "post_date": "2024.07.27",
        "post_excerpt": "バーテンダーに転身？ 異端のギャラリスト 南塚真史 の思考法",
        "post_tag": [
          "ART",
          "CULTURE",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/07/thumbnail_NANZUKA_TAKEN.jpg"
      },
      {
        "ID": "102695",
        "post_title": "対談 南貴之 × RYUSENKEI クニモンド瀧口 による「アルファミュージック再考」",
        "post_date": "2024.07.22",
        "post_excerpt": "レーベル創立55周年イヤーにVektor shop® とコラボレーション",
        "post_tag": [
          "CULTURE",
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/07/Thumbnail_ALFA_Minami_Takiguchi.jpg"
      },
      {
        "ID": "101888",
        "post_title": "ネペンテス とスタイリスト 服部昌孝 が仕掛ける 紫電（SHIDEN） とは？",
        "post_date": "2024.07.03",
        "post_excerpt": "日本のバイクカルチャーに根差した新ブランドが生まれた経緯を聞",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/07/thumbnail_Masataka_Hattori_Shiden.jpg"
      },
      {
        "ID": "101162",
        "post_title": "対談 : UNDERCOVER 髙橋盾 とnonnative 藤井隆行 が語る OZISM （後編）",
        "post_date": "2024.06.17",
        "post_excerpt": "後編 : それぞれの服作りの違い、そして“枯れる”美学について",
        "post_tag": [
          "CULTURE",
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/06/thumnail_OZISM_2.jpg"
      },
      {
        "ID": "101155",
        "post_title": "対談 : UNDERCOVER 髙橋盾 とnonnative 藤井隆行 が語る OZISM （前編）",
        "post_date": "2024.06.17",
        "post_excerpt": "前編 : 葉山でのクリエイティブライフ、小津安二郎 映画について",
        "post_tag": [
          "CULTURE",
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/06/thmbnail_OZISM_1.jpg"
      },
      {
        "ID": "100781",
        "post_title": "NAMACHEKO デザイナー Dilan Lurr（ディラン・ルー） インタビュー",
        "post_date": "2024.05.28",
        "post_excerpt": "その服に宿るアイデンティティとカルチャー",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/05/NAMACHEKO_thumbnail.jpg"
      },
      {
        "ID": "100531",
        "post_title": "古着の概念からテックウェアを変える CMF OUTDOOR GARMENTとは？",
        "post_date": "2024.05.09",
        "post_excerpt": "CMF デザイナー 奥谷誠（LOSTHILLS）インタビュー",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/05/Thumbnail_CMF.jpg"
      },
      {
        "ID": "100442",
        "post_title": "PORTER CLASSIC 吉田克幸 吉田玲雄 親子の肖像",
        "post_date": "2024.04.30",
        "post_excerpt": "時代を越える“格好良さ”を追求する、クラシックという美学",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/04/thumbnail_PORTER_CLASSIC.jpg"
      },
      {
        "ID": "100320",
        "post_title": "まだ日本が知らない日本ブランド norbit by Hiroshi Nozawa とは",
        "post_date": "2024.04.24",
        "post_excerpt": "海外バイヤーから熱視線を受けるアウトドア/ファッションブランドのデザイナーの肖像",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/04/sumnail_norbit.jpg"
      },
      {
        "ID": "99784",
        "post_title": "インタビュー   アーティスト KYNE の現在地",
        "post_date": "2024.03.30",
        "post_excerpt": "地元・福岡での大規模個展に向けて語る自身のルーツ、女性像の成り立ち",
        "post_tag": [
          "ART",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/03/KYNE_sumnail.jpg"
      },
      {
        "ID": "99139",
        "post_title": "インタビュー KAMIYA デザイナー 神谷康司",
        "post_date": "2024.03.07",
        "post_excerpt": "三原康裕のDNA、古着と雑踏酒場から生まれるファッション",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/03/sumnail_KAMIYA.jpg"
      },
      {
        "ID": "98950",
        "post_title": "Hender Scheme デザイナー 柏崎亮 の思考回路",
        "post_date": "2024.02.29",
        "post_excerpt": "そのプロダクト哲学、“循環”を志向する新業態 circulation を作った理由",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/02/Sumnail_henderScheme.jpg"
      },
      {
        "ID": "98617",
        "post_title": "MADNESS 10周年 ショーン・ユー Shawn Yueスペシャルインタビュー",
        "post_date": "2024.02.16",
        "post_excerpt": "日本ファッションとの繋がり、俳優業との両立、現在のライフスタイルまで語る",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/02/sumnail_ShawnYue.jpg"
      },
      {
        "ID": "98153",
        "post_title": "White Mountaineering 相澤陽介 のデザイン哲学",
        "post_date": "2024.01.31",
        "post_excerpt": "英国バイク Triumphとのコラボレーションから、そのリアルなデザインライフまで",
        "post_tag": [
          "FASHION",
          "FEATURE",
          "LIFESTYLE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/01/Sumnail_YosukeAizawa.jpg"
      },
      {
        "ID": "97683",
        "post_title": "窪塚洋介 は如何にしてゴルフを愛するようになったか",
        "post_date": "2024.01.25",
        "post_excerpt": "ゴルフブランド 8G SHOOTのプロデュース、独自の「人生攻略法」を語る",
        "post_tag": [
          "FASHION",
          "FEATURE",
          "LIFESTYLE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2024/01/sumnail_kubozuka.jpg"
      },
      {
        "ID": "97050",
        "post_title": "BED j.w. FORD 山岸慎平は静かに燃える",
        "post_date": "2023.12.27",
        "post_excerpt": "パリメンズコレクション2024AW直前独占インタビュー",
        "post_tag": [
          "FASHION",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2023/12/sumnail_BED.jw_.FORD_.jpg"
      },
      {
        "ID": "96865",
        "post_title": "インタビュー  蜷川実花とファッション",
        "post_date": "2023.12.19",
        "post_excerpt": "自ら語る写真観、ファッションの関係性",
        "post_tag": [
          "ART",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2023/12/sumnail_MikaNinagawa.jpg"
      },
      {
        "ID": "96503",
        "post_title": "インタビュー MADSAKI",
        "post_date": "2023.11.27",
        "post_excerpt": "ありし日の東京ナイトを描いた個展 “This Used to Be My Playground”",
        "post_tag": [
          "ART",
          "FEATURE"
        ],
        "meta_attached_file": "https://static.honeyee.com/wp-content/uploads/2023/11/MADSAKI_sumnail.jpg"
      }
    ]
  
  },
  methods: {
    
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>PREV</a>;
      } else if (type === "next") {
        return <a>NEXT</a>;
      }
      return originalElement;
    },
   
  },
};
</script>

<style lang="scss" scoped>
.list-container {
  position: relative;
  width: 100%;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgba(10, 10, 10, 0.6);
  }
  .list {
    padding: 120px 7% 10% 140px;
    .listTitle {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 58px;
      line-height: 67px;
      color: #232323;
      margin-bottom: 70px;
    }
    .content {
      width: 100%;
      display: flex;
      // align-items: center;
      flex-wrap: wrap;
      margin-bottom: 60px;
      justify-content: space-between;
      .newsBox {
        width: 30%;
        margin-bottom: 60px;
        .newsImg {
          width: 100%;
          display: flex;
          align-items: center;
          cursor: pointer;
          overflow: hidden;
          display: flex;
          img {
               
            min-height: 25vw;
            width: 100%;
            // max-height: 100%;
          }
        }
        .labelBox {
          width: 100%;
          min-height: 40px;
          margin-top: 24px;
          .newsLabel {
            height: 26px;
            display: inline-block;
            background: #646464;
            border-radius: 2px;
            font-family: Helvetica;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: #ffffff;
            padding: 5px 10px;
            margin: 0 12px 14px 0;
            cursor: pointer;
          }
        }
        .newsIntroduct {
          margin-bottom: 12px;
          font-family: Helvetica;
          font-size: 18px;
          line-height: 28px;
          color: #232323;
          width: 100%;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          height: 56px;
        }
        .newsContent {
          font-family: Helvetica;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: 0.05em;
          color: #787878;
          height: auto;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .newsDate {
          font-family: Helvetica;
          font-size: 12px;
          line-height: 20px;
          color: #787878;
        }
      }
    }
    ::v-deep.ant-pagination {
      width: 100%;
      text-align: center;
    }
    ::v-deep.ant-pagination-prev {
      float: left;
      height: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-prev a {
      font-family: Helvetica;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #232323;
      height: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-next {
      float: right;
      height: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-next a {
      font-family: Helvetica;
      font-weight: 300;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #232323;
      height: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-item {
      height: 60px;
      min-width: 60px;
      border: 0;
      border-radius: 0;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-jump-prev {
      height: 60px;
      min-width: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-jump-next {
      height: 60px;
      min-width: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-item-active {
      border-bottom: 1px solid #232323;
    }
  }
}
@media screen and (max-width: 1024px) {
  .list-container {
    .list {
      padding: 40 * $px 5% 10% 5%;
      .listTitle {
        font-family: Helvetica;
        font-weight: bold;
        font-size: 30 * $px;
        line-height: 34 * $px;
        color: #232323;
        margin-bottom: 20 * $px;
      }
      .content {
        width: 100%;
        .newsBox {
          width: 30%;
          margin-bottom: 30 * $px;
          .newsImg {
            width: 100%;
            max-height: 380px;
            display: flex;
            align-items: center;
            overflow: hidden;
            img {
              width: 100%;
              // max-height: 100%;
            }
          }
          .labelBox {
            width: 100%;
            min-height: 40px;
            margin-top: 24px;
            .newsLabel {
              height: 26px;
              display: inline-block;
              background: #646464;
              border-radius: 2px;
              font-family: Helvetica;
              font-style: normal;
              font-weight: normal;
              color: #ffffff;
              margin: 0 12px 14px 0;
            }
          }
          .newsIntroduct {
            margin-bottom: 12 * $px;
            font-family: Helvetica;
            color: #232323;
            max-height: 56 * $px;
            min-height: 28 * $px;
          }
          .newsContent {
            font-family: Helvetica;
            color: #787878;
            margin-bottom: 5 * $px;
          }
          .newsDate {
            font-family: Helvetica;
            font-size: 12px;
            line-height: 20px;
            color: #787878;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .list-container {
    .list {
      padding: 40 * $px 20 * $px 10% 20 * $px;
      .listTitle {
        font-family: Helvetica;
        font-weight: bold;
        font-size: 30 * $px;
        line-height: 34 * $px;
        color: #232323;
        margin-bottom: 10 * $px;
        margin-top: 10 * $px;
      }
      .content {
        width: 100%;
        display: block;
        .newsBox {
          width: 100%;
          margin-bottom: 30 * $px;
          border-bottom: 1px solid #efefef;
          .newsImg {
            width: 100%;
            height: 275 * $px;
            max-height: 275 * $px;
            display: flex;
            align-items: center;
            img {
              width: 100%;
              max-height: 100%;
            }
          }
          .newsDate {
            margin-bottom: 20 * $px;
          }
          .labelBox {
            width: 100%;
            min-height: 40px;
            .newsLabel {
              height: unset;
              display: inline-block;
              background: #646464;
              border-radius: 2px;
              font-family: Helvetica;
              font-style: normal;
              font-weight: normal;
              font-size: 12 * $px;
              line-height: 16 * $px;
              color: #ffffff;
              padding: 5 * $px 10 * $px;
              margin: 16 * $px 12 * $px 10 * $px 0;
            }
          }
        }
      }
      ::v-deep.ant-pagination-prev a {
        font-family: Helvetica;
        font-size: 12px;
        line-height: 14px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #232323;
        height: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-next {
        float: right;
        height: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-next a {
        font-family: Helvetica;
        font-weight: 300;
        font-size: 12px;
        line-height: 14px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #232323;
        height: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-item {
        height: 35 * $px;
        min-width: 35 * $px;
        border: 0;
        border-radius: 0;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-jump-prev {
        height: 35 * $px;
        min-width: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-jump-next {
        display: none;
        height: 35 * $px;
        min-width: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-item-active {
        border-bottom: 1px solid #232323;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// testList.vue